import { Link } from "@heroui/react";
import { SiMatrix } from "@icons-pack/react-simple-icons";

import { MATRIX_INVITE } from "../../../lib/constants";
import { Button } from "../../core/Button";

export const MatrixButton = () => {
  return (
    <Button
      as={Link}
      size="sm"
      href={MATRIX_INVITE}
      target="_blank"
      variant="ghost"
    >
      <SiMatrix size={18} />
      <p>Matrix</p>
    </Button>
  );
};
